import { IraUserOpenOrders } from 'screens';

const ReroutingToIraUserOpenOrders = (): JSX.Element => <IraUserOpenOrders />;

export default ReroutingToIraUserOpenOrders;
